<template>
  <div @click="expandCart(false)" class="cart-container" :class="[expanded == true ? 'expanded' : '', selectedAddonProducts.length > 0 ? 'hasProduct' : '',isSticking ? 'sticky' : '',step > 1 ? 'global' : '']">
      <div v-on:click.stop class="unexpanded-cart" :class="isSticking ? 'sticking' : ''" v-if="expanded == false">
        <div @click="expandCart(true)" class="expand-arrow">
            &lt;
        </div>
        <div v-if="step < 3" class="expand-cart bottom">
            <button :disabled="!canNext" @click="changePage(true)">Next ></button>
        </div>
        <div v-else class="expand-cart bottom">
            <button @click="expandCart(true)" :disabled="!canBundle" class="happybox-button green border" :class="isloading ? 'isLoading' : ''">{{ isloading ? "loading..." : "Next >"}}</button>
        </div>
        <p class="products-container-title">Your gift:</p>
        <ul class="products-container no-scrollbar scrollList">
            <li v-for="addonProduct in selectedAddonProducts" :key="addonProduct.variants[0].id">
                <div class="alert-overlay" v-if="!extendedAlert && isExtendedBoxes && extendedProducts.includes(addonProduct.title) && step == 2">
                    <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/ALERT.png?v=1733347991"  @click="() => {extendedAlert = true}" class="alert-icon"/>
                </div>
                <div v-if="extendedAlert && isExtendedBoxes && extendedProducts.includes(addonProduct.title) && step == 2" class="extended-block">
                    <p @click="() => {extendedAlert = false}" class="close">X</p>
                    <p><strong>Swap this gift for a smaller one to view cheaper box options</strong></p>
                    <div class="arrow-t">
                        <div class="inner"></div>
                    </div>
                </div>
                <div class="addon-container">
                    <img class="main-image" loading="lazy" :src="getProductImage(addonProduct)" >
                    <select  v-model="addonProduct.quantity" @change="changeOnDemand(addonProduct)">
                        <option v-for="qty in addonMaxQty(addonProduct)" :key="qty" :value="qty">{{qty}}</option>
                    </select>
                    <img @click="removeProduct(addonProduct)" class="delete-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/trash_05a3e1b5-b394-4f91-aaf3-599964c057cb.svg?v=1659632833">
                </div>
            </li>
            <li v-if="selectedBoxProduct">
                <div class="addon-container">
                    <img class="main-image" loading="lazy" :src="selectedBoxProduct | getProductImage" >
                    <img @click="goStep(2)" class="switch-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/SWITCH_ICON_c540ae0e-3dd9-476d-8c59-e50d94446d76.png?v=1723237048">
                </div>
            </li>
            <li v-if="selectedCardProduct">
                <div class="addon-container">
                    <img class="main-image" loading="lazy" :src="selectedCardProduct | getProductImage" >
                    <img @click="goStep(3)" class="switch-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/SWITCH_ICON_c540ae0e-3dd9-476d-8c59-e50d94446d76.png?v=1723237048">
                </div>
            </li>
        </ul>
        <p class="qty-box-title">Qty of Boxes:</p>
        <select v-model="selectedBoxQty" id="boxqtyselector" @change="changeBoxQty(null)">
            <option v-for="qty in boxMaxQty" :key="qty" :value="qty">{{qty}}</option>
        </select>
        <div class="price-container">
            <span class="title">Price per Box</span>
            <span class="price">{{ totalPrice | moneySaleFormat}}</span>
            <span v-if="valuePrice != totalPrice" class="title">Value per Box</span>
            <span v-if="valuePrice != totalPrice"  class="price">{{ valuePrice | moneySaleFormat}}</span>
        </div>
      </div>
      <div v-on:click.stop class="expanded-cart" v-else>
            <div @click="expandCart(false)" class="expand-arrow">
                >
            </div>
            <div class="product-summary-container no-scrollbar">
                <div class="box-name-container">
                    <p v-tooltip="{content: boxAlert, show: showBoxAlert, trigger: ['manual']}" class="box-name" v-if="isEditingName == false">{{boxName}}</p>
                    <input v-on:keyup.enter="editName(false)" @blur="checkName()" v-if="isEditingName == true" type="text" maxlength="34" v-model="boxName">
                    <button class="box-name-legend" @click="editName(true)" v-if="isEditingName == false"> <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/icon.png?v=1658429893"/>Give your box a name to keep your cart organized</button>
                </div>
                <div class="product-summary">
                    <p class="summary-title">Box Contents</p>
                    <p class="summary-subtitle" v-if="productQtyCopy">{{ productQtyCopy }}</p>
                    <ul class="products-container">
                        <li v-for="addonProduct in selectedAddonProducts" :key="addonProduct.variants[0].id">
                            <div class="addon-container">
                                <div class="image-container">
                                    <img @click="openModalProduct(addonProduct)" class="main-image lazyload" width="100" height="100" loading="lazy" :src="getProductImage(addonProduct)" >
                                </div>
                                <div class="product-information">
                                    <div>
                                        <p @click="openModalProduct(addonProduct)" class="title">{{addonProduct.title}}</p>
                                        <p class="price">${{addonProduct.variants[0].price}}</p>
                                    </div>
                                    <div class="product-qty-container">
                                        <select v-model="addonProduct.quantity" @change="changeOnDemand(addonProduct)">
                                            <option v-for="qty in addonMaxQty(addonProduct)" :key="qty" :value="qty">{{qty}}</option>
                                        </select>
                                        <img @click="removeProduct(addonProduct)" class="delete-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/trash_05a3e1b5-b394-4f91-aaf3-599964c057cb.svg?v=1659632833">
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li v-if="selectedBoxProduct">
                            <div class="addon-container">
                                <div class="image-container">
                                    <img class="main-image lazyload" width="100" height="100" :src="selectedBoxProduct | getProductImage" >
                                </div>
                                <div class="product-information">
                                    <div>
                                        <p class="title">{{selectedBoxProduct.title}}</p>
                                        <p class="price">${{selectedBoxProduct.variants[0].price}}</p>
                                    </div>
                                    <div class="product-qty-container">
                                        <img @click="goStep(2)" class="switch-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/SWITCH_ICON_c540ae0e-3dd9-476d-8c59-e50d94446d76.png?v=1723237048">
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li v-if="selectedCardProduct">
                            <div class="addon-container">
                                <div class="image-container">
                                    <img class="main-image lazyload" width="100" height="100" :src="selectedCardProduct | getProductImage" >
                                </div>
                                <div class="product-information">
                                    <div>
                                        <p class="title">{{selectedCardProduct.title}}</p>
                                        <p class="price">${{selectedCardProduct.variants[0].price}}</p>
                                    </div>
                                    <div class="product-qty-container">
                                        <img @click="goStep(3)" class="switch-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/SWITCH_ICON_c540ae0e-3dd9-476d-8c59-e50d94446d76.png?v=1723237048">
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <button @click="goStep(1)" class="remove-all">Edit gifts</button>
                </div>
                <div class="box-container">
                    <div class="box-qty-container">
                        <p>Box Quantity</p>
                        <div class="box-qty-input-container">
                            <button @click="incrementBoxQty(false)">-</button> 
                            <input @blur="changeBoxQty(null)" v-model="selectedBoxQty" type="number" min="1"> 
                            <button @click="incrementBoxQty(true)">+</button> 
                        </div>
                    </div>
                    <p class="multiship-notice">Adjust the quantity if you'd like duplicates of this box, even if you're shipping to different addresses!</p>
                    <p class="custom-notice" v-if="customAlert && hasCustomProducts">{{customAlert}}</p>
                </div>
                <div v-if="recommendedAddons.length > 0" class="recommendation-container">
                    <p class="title">Perfect fit for your box</p>
                    <div class="recommended-addon-container">
                        <div class="recommended-addon" v-for="addon in recommendedAddons" :key="addon.id">
                            <img @click="openModalProduct(addon)" width="180" height="180" loading="lazy" :src="addon.image.src" class="main-image">
                            <button @click="updateReccomendedAddonProductQuantity(addon)" class="happybox-button white border">{{ addCopy }}</button>
                            <p @click="openModalProduct(addon)" class="addon-title">{{addon.title}}</p>
                            <p class="price">{{addon.variants[0].price | moneySaleFormat}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="price-summary-container no-scrollbar">
                <div class="x-container">
                    <img @click="expandCart(false)" class="x-button" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x"/>
                </div>
                <div class="notice-container">
                    <img class="main-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/boxwings.svg?v=1658459692"/>
                    <div>
                        <p class="title">Multiple addresses? No problem!</p>
                        <p class="subtitle">Ship to one or many locations all <br/> in one, easy checkout</p>
                    </div>
                </div>
                <div class="summary-container">
                    <div class="item-summary">
                        <p class="item-title">Box Summary</p>
                        <div class="box-total">
                            <div class="total-container">
                                <p v-if="boxQty > 1" class="title"><strong>({{boxQty}})</strong> {{boxName}}</p>
                                <p v-else class="title">{{boxName}}</p>
                                <p class="price">{{ gifsPrice * boxQty | moneySaleFormat}}</p>
                            </div>
                            <p class="individual-price">{{gifsPrice | moneySaleFormat}} per box</p>
                        </div>
                        <div class="box-total">
                            <div class="total-container">
                                <p class="title">Gift Box Design <span v-if="!selectedBoxProduct">(selected at next step)</span></p>
                                <p v-if="selectedBoxProduct" class="price">{{ boxPrice * boxQty | moneySaleFormat }}</p>
                                <p v-else class="price">$--</p>
                            </div>
                        </div>
                        <div class="box-total">
                            <div class="total-container">
                                <p class="title">Card <span v-if="!selectedCardProduct">(selected at future step)</span></p>
                                <p v-if="selectedCardProduct" class="price">{{ cardPrice * boxQty | moneySaleFormat }}</p>
                                <p v-else class="price">$--</p>
                            </div>
                        </div>
                        <div class="box-total">
                            <div class="total-container">
                                <p class="title">Handpacking Fee</p>
                                <p class="price">{{ feePrice * boxQty | moneySaleFormat }}</p>
                            </div>
                            <p class="purple-legend" v-if="hasOnDemandProducts"> Some items in your cart may  require 1-2 week lead time.  But trust us, they're worth the wait!</p>
                            <p v-else-if="hasCustomProducts" class="individual-price">Custom items require a lead time of at least 1-2 weeks. Our team will reach out via email to coordinate shipping details.</p>
                        </div>
                        <div class="item-total">
                            <p class="title">Item Total</p>
                            <p class="price">{{(totalPrice * boxQty) | moneySaleFormat}}</p>
                        </div>
                    </div>
                    <div class="taxes-container">
                        <p class="title">Taxes <strong>(calculated in checkout)</strong></p>
                        <p class="price">--</p>
                    </div>
                    <div class="separator"></div>
                    <div class="subtotal-container">
                        <p class="title">Estimated Subtotal</p>
                        <p class="price">{{(totalPrice * boxQty) | moneySaleFormat}}</p>
                    </div>
                </div>
                <div v-if="step != 3" class="complete-box">
                    <button @click="changePage(true)" class="happybox-button green border" :class="isloading ? 'isLoading' : ''">{{ isloading ? "loading..." : "Next >"}}</button>
                </div>
                <div v-else class="complete-box">
                    <button :disabled="!canBundle" @click="bundle()" class="happybox-button green border" :class="isloading ? 'isLoading' : ''">{{ bundleText }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { mapGetters } from 'vuex';
export default {
    props: {
        isSticking: Boolean,
        step: Number,
        fromCard: Boolean
    },
    data() {
      return {
        expanded: false,
        isEditingName: false,
        selectedBoxQty: 1,
        isHovering: false,
        boxAlert: '',
        showBoxAlert: false,
        isloading: false,
        extendedAlert: false,
      }
    },
    watch: {
        boxQty: {
            handler(val){
                this.selectedBoxQty = val;
            },
            deep: true
        },
        cartLength:{
            handler(val,oldVal){
                if(val == 0 && this.step != 1){
                    this.goStep(1);
                }
                this.scrollBottom();
            }
        },
        selectedBoxProduct:{
            handler(){
                this.scrollBottom();
            }
        },
        selectedCardProduct:{
            handler(){
                this.scrollBottom();
            }
        }
    },
    computed:{
        ...mapGetters([
            'selectedAddonProducts',
            'maxCapacity',
            'currentCapacity',
            'productLimit',
            'addCopy',
            'defaulBoxName',
            'cartNames',
            'addonProducts',
            'boxQty',
            'selectedCardProduct',
            'selectedBoxProduct',
            'feeProduct',
            'budget',
            'currentBudget',
            'selectedOccasion',
            'selectedCategories',
            'selectedFilters',
            'boxProducts'
        ]),
        canNext(){
            if(this.step == 1){
                return true
            }
            else if (this.step == 2 && this.selectedBoxProduct){
                return true;
            }

            return false
        },
        cartLength(){
            return this.selectedAddonProducts.length;
        },
        currentMaxCapacity(){
            if(!this.selectedBoxProduct){
                return this.maxCapacity;
            }
            else{
                return parseInt(this.selectedBoxProduct.variants[0].option1)
            }
        },
        recommendedAddons(){
            if(this.addonProducts.length > 0){
                let filterAddons =  JSON.parse(JSON.stringify(this.addonProducts));
                //filter via occasion
                if(this.selectedOccasion.length > 0){
                    filterAddons = filterAddons.filter(x => x.tags.some(y => this.selectedOccasion.some(z => y.includes(z))));
                }

                //Filter categories
                if(!this.selectedCategories.includes("View All"))
                    filterAddons = filterAddons.filter(x => x.tags.some(y =>  this.selectedCategories.some(z => y.includes(z))));

                //Filter for each category
                for(let filter of this.selectedFilters){
                    filterAddons = filterAddons.filter(x => filter.filters.some(y => x.tags.includes(y)));
                }

                //Exclude products
                let excludeFilters = this.selectedAddonProducts.filter(x => x.tags.some(y => y.includes("Exclude_")));
                if(excludeFilters.length > 0){
                    let excludedTags = excludeFilters.flatMap(x => x.tags.filter(y => y.includes("Exclude_")));
                    excludedTags = excludedTags.map(x => parseInt(x.replaceAll("Exclude_","")));
                    filterAddons = filterAddons.filter(x => !excludedTags.includes(x.id));
                }
            
                var addonCartIds = this.selectedAddonProducts.map(x => x.id);
                if(filterAddons.length > 0){
                    let products = filterAddons.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude")) && ((parseInt(x.variants[0].price) + this.currentBudget) <= this.budget)).slice(0,3);
                    return products.sort((a,b) => a.capacity - b.capacity);
                }
                else{
                    return this.addonProducts.filter(x => !addonCartIds.includes(x.id) && x.tags.every(y => !y.includes("Brandable Swag") && !y.toLowerCase().includes("Pairs_exclude"))).sort((a,b) => a.capacity - b.capacity && ((parseInt(x.variants[0].price) + this.currentBudget) <= this.budget)).slice(0,3);
                }
            }

            return [];
        },
        gifsPrice(){
            if(this.selectedAddonProducts.length > 0){
               return this.selectedAddonProducts.map(x => x.variants.length ? parseFloat(x.variants[0].price * x.quantity) : 0)
                .reduce((prev, next) => prev + next, 0);
            }

            return 0;
        },
        boxPrice(){
            if(this.selectedBoxProduct)
                return parseFloat(this.selectedBoxProduct.variants[0].price);

            return 0
        },
        cardPrice(){
            if(this.selectedCardProduct){
                return parseFloat(this.selectedCardProduct.variants[0].price);
            }

            return 0;
        },
        feePrice(){
            if(this.feeProduct){
                return parseFloat(this.feeProduct.variants[0].price / 100);
            }

            return 0;
        },
        totalPrice(){
            let total = 0;
            if(this.selectedAddonProducts.length > 0){
               total += this.selectedAddonProducts.map(x => x.variants.length ? parseFloat(x.variants[0].price * x.quantity) : 0)
                .reduce((prev, next) => prev + next, 0);
            }
            if(this.selectedBoxProduct){
                total += parseFloat(this.selectedBoxProduct.variants[0].price);
            }
            if(this.selectedCardProduct){
                total += parseFloat(this.selectedCardProduct.variants[0].price);
            }
            if(this.feeProduct){
                total += parseFloat(this.feeProduct.variants[0].price / 100);
            }

            return total.toFixed(2)
        },
        valuePrice(){
            let total = 0;
            if(this.selectedAddonProducts.length > 0){
               total += this.selectedAddonProducts.map(x => x.variants.length ? parseFloat((x.variants[0].value_price ||x.variants[0].price) * x.quantity) : 0)
                .reduce((prev, next) => prev + next, 0);
            }
            if(this.selectedBoxProduct){
                total += parseFloat(this.selectedBoxProduct.variants[0].value_price || this.selectedBoxProduct.variants[0].price);
            }
            if(this.selectedCardProduct){
                total += parseFloat(this.selectedCardProduct.variants[0].value_price || this.selectedCardProduct.variants[0].price);
            }
            if(this.feeProduct){
                total += parseFloat(this.feeProduct.variants[0].price / 100);
            }

            return total.toFixed(2)
        },
        boxMaxQty(){
            var boxMax =  [250,this.boxQty];
            const min = 1,
            max = Math.max(...boxMax),
            interval = 1;
            const length = (max - min) / interval + 1;
            const arr = Array.from({ length }, (_, i) => min + i * interval);
            return arr;
        },
        shippingPrice(){
            return 12
        },
        boxQty: {
            get(){ return this.$store.state.boxQty},
            set(value){this.$store.commit('setBoxQty', value )}
        },
        boxName: {
            get(){ return this.$store.state.boxName},
            set(value){this.$store.commit('setBoxName', value )}
        },
        leftOverCapacity(){
            return this.currentMaxCapacity - this.currentCapacity;
        },
        lesserMaxCapacity(){
            //get biggest box that is not extended
            let capacities = this.boxProducts.filter(x => !x.title.toLowerCase().includes("extended")).map(x => x.variants).flat().filter(x => x.available).map(x => parseInt(x.option1)).sort((a,b) => b - a);
            return capacities.find(x => x < this.currentMaxCapacity)
        },
        isExtendedBoxes(){
            return this.currentCapacity > this.lesserMaxCapacity;
        },
        extendedProducts(){
            if(this.isExtendedBoxes){
                //find a product that when removed jumps to not extended box
                let cartProducts = JSON.parse(JSON.stringify(this.selectedAddonProducts))
                let products = cartProducts.sort((a,b) => b.capacity - a.capacity);//.find(x => (this.currentCapacity - x.capacity) <= this.lesserMaxCapacity);
                let titles = [];
                let capacity = Number(this.currentCapacity);
                for(let i = 0; capacity > this.lesserMaxCapacity; i++){
                    titles.push(products[i].title);
                    capacity = capacity - (products[i].capacity * products[i].quantity);
                }

                return titles.join(", ");
            }

            return null
        },
        totalQtyProducts(){
            return this.selectedAddonProducts.map(x => x.quantity).reduce((prev, next) => prev + next, 0);
        },
        shouldHover(){
            if(this.canAddMore == false && this.isHovering == true){
                return true;
            }
            return false;
        },
        canAddMore(){
            var canAddArray = this.selectedAddonProducts.every((x) =>{
                return ((this.boxQty + 1) * x.quantity) <= this.productCurrentVariantInventory(x)
            })

            return canAddArray
        },
        hasCustomProducts(){
            return this.selectedAddonProducts.some(x => x.tags.some(y => y.includes("Customizable")))
        },
        hasOnDemandProducts(){
            return this.selectedAddonProducts.some(x => x.variants[0].sku.toLowerCase().includes("ondemand"))
        },
        customAlert(){
            let productList = this.selectedAddonProducts.filter(x => x.tags.some(x => x.includes("QTYMIN") && !x.includes("DEMAND")));
            if(productList.length > 0){
                var productTitles = productList.map(x => x.title);
                let minQtys = productList.map((x) =>{
                    let minTag = x.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND"));
                    if(minTag){
                        minTag = minTag.split("_");
                        minTag = minTag[minTag.length - 1];
                        return minTag;
                    }

                    return 1
                })
                let maxQty = Math.max([...minQtys])
                return `Please note: "${productTitles.join(", ")}" requires a minimum of ${maxQty} units to be included in your boxes. If you lower your box quantity below this amount, this item will be removed`
            }

            return null
        },
        canBundle(){
            return this.selectedAddonProducts.length > 0 && this.selectedBoxProduct && this.selectedCardProduct;
        },
        productQtyCopy(){
            if(this.totalQtyProducts == 1)
                return "Great start! We recommend adding a few more items to fill your gift box."
            if(this.totalQtyProducts < 5)
                return "Nice picks! Pro-tip: boxes look best with 5-7 items"
            if(this.totalQtyProducts < 8)
                return "Wow, this gift looks fantastic."
            if(this.totalQtyProducts >= 8)
                return "You’re a gifting pro! They’re going to love it."

            return null;
        },
        bundleText(){
            if(!this.selectedCardProduct)
                return "You haven't selected your card!"
            else if(this.isloading){
                return "loading..."
            }
            else 
                return "Proceed to cart"
        }
    },
    methods:{
        removeProduct(product){
            this.$store.commit('removeSelectedAddonProductNew', product);
        },
        expandCart(expand){
            this.expanded = expand;
        },
        editName(edit){
            this.showBoxAlert = false;
            this.isEditingName = edit;
        },
        incrementBoxQty(increment){
            if(increment){
                this.changeBoxQty(this.boxQty + 1)
            }
            else {
                if(this.boxQty > 1){
                    this.changeBoxQty(this.boxQty - 1)
                }
            }
        },
        addonMaxQty(addon){
            const min = 1,
            max = this.getProductMaxQty(addon),
            interval = 1;
            const length = (max - min) / interval + 1;
            let arr = Array.from({ length }, (_, i) => min + i * interval);

            if(this.demandQtyMin(addon) > 0){
                arr = this.checkOnDemandArray(arr,addon);
            }

            return arr;
        },
        getProductMaxQty(addon){
            //Get max value posible in products, no more than the product limit per box
            let realLimit = addon.corporate ? 999 : this.productLimit
            var maxValues = [realLimit]
            //Get limit based on inventory * total boxes
            let inventoryQty = this.productCurrentVariantInventory(addon)
            maxValues.push(Math.floor( inventoryQty / this.boxQty));
            //Get limit based on currentCapacity
            let maxPerCapacity = Math.max(...[Math.floor((this.currentMaxCapacity - this.currentCapacity) / addon.capacity + this.getProductCurrentQty(addon)),this.getProductCurrentQty(addon)])
            maxValues.push(maxPerCapacity);
            return Math.min(...maxValues)
        },
        getProductCurrentQty(currentProduct){
          var product = this.selectedAddonProducts.find(x => x.id == currentProduct.id);
          if(product)
            return product.quantity
          return 0
        },
        updateReccomendedAddonProductQuantity(product){
            var productQty = this.getProductCurrentQty(product) + 1;
            this.$store.commit('updateSelectedAddonProductsNew',{product: product, quantity: productQty});
        },
        changePage(increment){
            this.$emit("changepage", increment);
        },
        changeBoxQty(qty){
            //Validate if cart products can support box qty if not show alert
            this.selectedBoxQty = qty ? qty : this.selectedBoxQty
            var canUpdate = this.selectedAddonProducts.filter((x) =>{
                let demandQty = this.demandQtyMin(x);
                if(demandQty >= this.selectedBoxQty)
                    return false
                if((this.selectedBoxQty * (x.quantity)) > this.productCurrentVariantInventory(x) )
                    return true

                return false
            })

            let customizableUpdate = this.selectedAddonProducts.filter((x) =>{
                if(x.tags.some(x => x.includes("QTYMIN") && !x.includes("DEMAND"))){
                    let minTag = x.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND"));
                    if(minTag){
                        minTag = minTag.split("_");
                        minTag = minTag[minTag.length - 1];
                        if(this.selectedBoxQty < parseInt(minTag)){
                            return true;
                        }
                    }
                }

                return false
            })

            let ondemandUpdate = this.selectedAddonProducts.filter((x) =>{
                let demandQty = this.demandQtyMin(x);
                if(demandQty > 0){
                    let product = this.addonProducts.find(y => y.id == x.id);
                    let notDemand = product.variants.find(y => !y.sku.toLowerCase().includes("ondemand"));
                    if(this.selectedBoxQty * x.quantity < demandQty && notDemand.inventory_quantity < this.selectedBoxQty * x.quantity){
                        return true;
                    }
                }

                return false
            })

            

            if(customizableUpdate.length > 0){
                this.openBoxQtyCustomConfirmation(customizableUpdate);
            }
            else if(ondemandUpdate.length > 0){
                this.openBoxQtyOnDemandConfirmation(ondemandUpdate);
            }
            else if(canUpdate.length > 0){
                this.openBoxQtyConfirmation(canUpdate);
            }
            else {
                this.boxQty = this.selectedBoxQty;
                this.checkOnDemand();
            }
        },
        openBoxQtyConfirmation(productList){
            var productTitles = productList.map(x => x.title);
            const alertText = "The following product(s) don't have enough inventory to match the quantity of boxes you've requested: " + productTitles.join(", ") + ". Here are your options:";
            Swal.fire({
                title: 'Uh oh...',
                text: alertText,
                showCancelButton: true,
                confirmButtonText: "I'll remove them from all boxes (& maybe add something else!)",
                cancelButtonText: "I'll take what you have (& reduce my number of boxes)",
                reverseButtons: true,
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup-2",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                    cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.boxQty = this.selectedBoxQty
                    this.checkOnDemand();
                } else if ( result.dismiss === Swal.DismissReason.cancel )
                {
                    this.selectedBoxQty = this.boxQty;
                }
                else{
                    this.selectedBoxQty = this.boxQty;
                }
            })
        },
        openBoxQtyOnDemandConfirmation(productList){
            var productTitles = productList.map(x => x.title);
            let minQtys = productList.map((x) =>{
                let minTag = x.tags.find(x => x.includes("DEMAND_QTYMIN"));
                if(minTag){
                    minTag = minTag.split("_");
                    minTag = minTag[minTag.length - 1];
                    return minTag;
                }

                return 1
            })
            let maxQty = Math.max([...minQtys])
            const alertText = `Please note: "${productTitles.join(", ")}" requires a minimum of ${maxQty} units to be included in your boxes. If you lower your box quantity below this amount, this item will be removed`
            Swal.fire({
                title: 'Uh oh...',
                text: alertText,
                showCancelButton: true,
                confirmButtonText: "I'll remove them from all boxes (& maybe add something else!)",
                cancelButtonText: "I'll keep my boxes",
                reverseButtons: true,
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup-2",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                    cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.changeBoxQty();
                } else if ( result.dismiss === Swal.DismissReason.cancel )
                {
                    this.selectedBoxQty = this.boxQty;
                }
                else{
                    this.selectedBoxQty = this.boxQty;
                }
            })
        },
        openBoxQtyCustomConfirmation(productList){
            const alertText = this.customAlert;
            Swal.fire({
                title: 'Uh oh...',
                text: alertText,
                showCancelButton: true,
                confirmButtonText: "I'll remove them from all boxes (& maybe add something else!)",
                cancelButtonText: "I'll keep my boxes",
                reverseButtons: true,
                customClass:{
                    container:"swal-custom-container",
                    popup: "swal-custom-popup",
                    title:"swal-title",
                    confirmButton: "happybox-button green border",
                    cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.changeBoxQty();
                } else if ( result.dismiss === Swal.DismissReason.cancel )
                {
                    this.selectedBoxQty = this.boxQty;
                }
                else{
                    this.selectedBoxQty = this.boxQty;
                }
            })
        },
        checkName(){
            if(this.boxName == ""){
                this.boxAlert = "Box name cannot be empty";
                this.showBoxAlert = true;
                this.boxName = this.defaulBoxName;
            }
            else if (this.cartNames.includes(this.boxName)){
                this.boxAlert = "Another box has the same name"
                this.showBoxAlert = true;
                this.boxName = this.defaulBoxName;
            }
            else {
                this.boxAlert = ""
                this.showBoxAlert = false;
            }
            let that = this;
            setTimeout(() => {that.showBoxAlert = false;}, 2000);
            this.isEditingName = false;
        },
        removeAll(){
            this.$store.commit('updateAllSelectedAddonProducts', []);
            this.expandCart(false);
        },
        openModalProduct(product){
            this.$emit("openmodal",product);
            this.expandCart(false);
        },
        getProductImage(product){
            if(product.properties){
                let hasImage = product.properties.find(y => y.name == "_customUrl");
                if(hasImage){
                    return hasImage.value;
                }
            }
            if(product.variants[0].featured_image){
                return product.variants[0].featured_image.src;
            }

            return (product.images.length > 0) ? product.images[product.images.length - 1].src : '';
            
        },
        isOnDemand(addon){
            let product = this.addonProducts.find(x => x.id == addon.id);
            return product.variants.some(x => x.sku.toLowerCase().includes("ondemand"));
        },
        productCurrentVariantInventory(product){
            if(this.isOnDemand(product))
                return 9999;
            return product.variants[0].inventory_quantity;
        },
        changeOnDemand(addonProduct){
            if(this.isOnDemand(addonProduct)){
                let product = this.addonProducts.find(x => x.id == addonProduct.id);
                var variantProduct = JSON.parse(JSON.stringify(product));
                let notDemand = variantProduct.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
                let onDemand = variantProduct.variants.find(x => x.sku.toLowerCase().includes("ondemand"));
                if(notDemand.inventory_quantity >= addonProduct.quantity * this.boxQty  || this.demandQtyMin(addonProduct) > this.boxQty * addonProduct.quantity){
                    variantProduct.variants = [notDemand];
                }
                else 
                    variantProduct.variants = [onDemand];

                if(addonProduct.variants[0].id != variantProduct.variants[0].id){
                    this.$store.commit('updateSelectedAddonProductsNew',{product: addonProduct, quantity: 0});
                    this.$store.commit('updateSelectedAddonProductsNew',{product: variantProduct, quantity: addonProduct.quantity});
                }
            }
        },
        checkOnDemand(){
            let cartIds = this.selectedAddonProducts.map(x => x.id);
            let onDemandProducts = this.addonProducts.filter(x => cartIds.includes(x.id) && x.variants.some(y => y.sku.toLowerCase().includes("ondemand")));
            if(onDemandProducts.length > 0){
                let ondemandIds = onDemandProducts.map(x => x.id);
                let ondemandCartProducts = this.selectedAddonProducts.filter(x => ondemandIds.includes(x.id));
                for(let addon of ondemandCartProducts){
                    this.changeOnDemand(addon)
                }
            }
        },
        demandQtyMin(addon){
            let demandQtymin = addon.tags.find(x => x.includes("DEMAND_QTYMIN"));
            if(demandQtymin){
                if(demandQtymin){
                    demandQtymin = demandQtymin.split("_");
                    demandQtymin = demandQtymin[demandQtymin.length - 1];

                    return  parseInt(demandQtymin);
                }
            }

            return 0;
        },
        checkOnDemandArray(arr,addon){
            let demandMinQty = this.demandQtyMin(addon);
            let product = this.addonProducts.find(x => x.id == addon.id);
            const notDemand = product.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
            const notDemandInventory = notDemand.inventory_quantity;
            for(let int of arr){
                if((int * this.boxQty) < demandMinQty && (int * this.boxQty) > notDemandInventory)
                arr.splice(int-1,1);
            }

            return arr;
        },
        bundle(){
            this.isloading = true;
            this.$emit("bundle");
        },
        scrollBottom(){
            setTimeout(() => {
                    let elements = document.getElementsByClassName("scrollList");
                    for(let element of elements){
                        element.scrollTop = element.scrollHeight;
                    }
                }, 100);
        },
        goStep(step){
            this.$emit("gostep",step);
            this.expanded = false;
        }
    },
    mounted() {
        this.selectedBoxQty = this.boxQty;
    }
}
</script>

<style lang="scss" scoped>

.cart-container{
    width: 0%;
    height: 100%;
    display: none;
}

.cart-container.hasProduct{
    width: 100%;
    display: block;
    min-width: 10%;
    z-index: 3;
}

.sticky.cart-container.hasProduct{
    width: 10%;
}

.cart-container.global{
    position: fixed;
    width: 10%;
    right: 0px;
    top: 0px;
    background-color: white;
}

.cart-container.expanded.global{
    top: 0%;
    height: 100%;
}

.sticky.cart-container.global{
    top: 45px;
}

.sticky.cart-container.hasProduct.expanded{
    width: 100%;
    height: calc(100vh - 44px);
    top: 44px;
    bottom: 0;
    position: fixed;
    z-index: 3;
}

.cart-container.expanded{
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0px;
    left: 0%;
    display: flex;
    justify-content: flex-end;
    height: 100vh;
    z-index: 4;
}

.separator{
    width: 100%;
    height: 1px;
    background-color: #D1D5DB;
    margin: 2% 0%;
}

//Unexpanded cart css
.unexpanded-cart{
    width: 100%;
    height: 100%;
    box-shadow: 0px 10px 15px rgba(31, 41, 55, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: sticky;
    top: 45px;
    height: calc(100vh - 45px);
}

.unexpanded-cart.sticking{
    height: calc(100vh - 45px);
    top: 45px;
}

.price-container{
    display: flex;
    flex-direction: column;
    text-align: center;
    box-shadow: inset 0px 1px 0px #E6E8EC;
    width: 100%;
    padding: 5% 0%;
    position: sticky;
    bottom: 0;
}

.price-container .title{
    font-weight: bold;
    font-size: 1.15vw;
}

.price-container .price{
    font-size: 1.3vw;
}

.unexpanded-cart .expand-arrow{
    position: absolute;
    background-color: white;
    border-bottom: 1px solid #E5E7EB;
    border-left: 1px solid #E5E7EB;
    border-top: 1px solid #E5E7EB;
    border-radius: 4px 0px 0px 4px;
    top: 5%;
    left: -25%;
    width: 25%;
    height: 4%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #374151;
    font-size: 2vw;
    cursor: pointer;
}

.qty-box-title{
    font-weight: bold;
    font-size: 1.15vw;
    line-height: 1.5;
}

#boxqtyselector{
    background-color: #FFFFFF;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px;
    padding: 0% 0% 0% 10%;
    height: unset;
    width: 70%;
    margin-bottom: 1rem;
}

.products-container-title{
    font-weight: bold;
    font-size: 1.15vw;
    line-height: 1.5;
    padding: 10% 0%;
}

.unexpanded-cart .products-container{
    width: 90%;
    display: flex;
    flex-direction: column;
    list-style: none;
    justify-content: flex-start;
    margin: unset;
    max-height: 67%;
    flex: 1;
    overflow-y: scroll ;
}


.unexpanded-cart .products-container li{
    width: 100%;
    margin-bottom: 1vw;
    position: relative;
}

.unexpanded-cart .addon-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.unexpanded-cart .addon-container .main-image{
    width: 90%;
    background-color: #f6f6f6;
    border: unset;
    margin-bottom: 5%;
}

.addon-container select{
    width: 50%;
    background-color: #FFFFFF;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px;
    padding: 0% 0% 0% 10%;
    height: unset;
    margin-right: 10%;
}
.delete-button{
    width: 30%;
    background: #FFFFFF;
    border-radius: 4px;
    cursor: pointer;
}

.delete-button.disabled{
    opacity: 0.5;
}

.switch-button{
    width: 30%;
    padding: 6%;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 65%;
    box-shadow: 0 1px 2px #1f293714;
    border: 1px solid #F3EEFA;
}

.product-qty-container .switch-button{
    width: 20%;
    margin: unset;
    padding: 3%;
}

.expand-cart.bottom{
    background: #FFFFFF;
    padding: 10px;
    width: 100%;
    position: sticky;
    bottom: 0;
}

.expand-cart.bottom button{
    background-color: #5cffc0;
    padding: 8% 0%;
    width: 100%;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 100px;
    transform: matrix(1, 0, 0, 1, 0, 0);
    font-family: 'Karla';
    font-style: normal;
    font-weight: 700;
    font-size: 1.15vw;
    line-height: 1.5;
    text-align: center;
    color: #0F0C38;
    border: 1px solid #0F0C38;
}

.expand-cart.bottom button:disabled{
  opacity: 0.6;
}

.expand-cart.bottom button:hover{
    background-color: #27F0A2;
}

//Expanded Cart Css
.expanded-cart{
    width: 72%;
    height: 100%;
    background-color: white;
    display: flex;
    position: relative;
}

.expanded-cart .expand-arrow{
    position: absolute;
    background-color: white;
    border-bottom: 1px solid #E5E7EB;
    border-left: 1px solid #E5E7EB;
    border-top: 1px solid #E5E7EB;
    border-radius: 4px 0px 0px 4px;
    top: 10%;
    left: -3.5%;
    width: 3.5%;
    line-height: 1.2;
    display: flex;
    justify-content: center;
    color: #374151;
    font-size: 2vw;
    cursor: pointer;
    align-items: center;
}

.product-summary-container{
    width: 60%;
    display: flex;
    flex-direction: column;
    padding: 0% 2%;
    overflow-y: scroll;
}

.product-summary{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border: 1px solid #E8E1F2;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 16px;
}

.price-summary-container{
    width: 40%;
    background-color: #F9FAFB;;
    padding: 0% 2%;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    height: 100%;
    position: relative
}

.box-name-container{
    width: 100%;
    display: flex;
    padding: 3% 0%;
}

.box-name{
    font-weight: bold;
    line-height: 1.33;
    font-size: 1.67vw;
}

.box-name-legend{
    color: #66498C;
    line-height: 1.43;
    font-size: 1vw;
    padding-left: 3%;
    display: flex;
    align-items: center;
    width: 65%;
}

.box-name-legend img{
    width: 4%;
    margin-right: 2%;
}

.expanded-cart .products-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: space-between;
    margin: unset;
    padding: 5% 2%;
}


.expanded-cart .products-container li{
    width: 45%;
}

.expanded-cart .addon-container{
    width: 100%;
    display: flex;
    align-items: center;
}

.expanded-cart .addon-container .image-container{
    width: 40%;
    display: flex;
}

.expanded-cart .addon-container .main-image{
    width: 100%;
    height: auto;
    background-color: #f6f6f6;
    cursor: pointer;
}

.expanded-cart .product-information{
    width: 60%;
    display: flex;
    flex-direction: column;
    padding-left: 5%;
    justify-content: space-between;
}

.expanded-cart .product-information .title{
    line-height: 1.43;
    font-size: 0.9vw;
    font-weight: bold;
    cursor: pointer;
}

.expanded-cart .product-information .price{
    line-height: 1.43;
    font-size: 1vw;
}

.product-qty-container{
    width: 100%;
    display: flex;
}

.product-qty-container select{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7 !important;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px !important;
    height: unset !important;
    padding: 1% 2% !important;
    text-align: center;
    font-size: 1.3vw;
    width: 80% !important;
    line-height: 1.5;
    -moz-appearance: textfield;
}

.product-qty-container .delete-button{
    width: 20%;
}

.box-container{
    background-color: #F9FAFB;
    margin-top: 5%;
    padding: 0% 2% 2% 2%;
}

.box-qty-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3% 0%;
}
.box-qty-container p{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 700;
    font-size: 1.2vw;
    line-height: 1.5;
    color: #0F0C38;
}


.box-qty-input-container{
    width: 50%;
    display: flex;
    justify-content: flex-end;
}

.box-qty-input-container input{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7 !important;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px !important;
    height: unset !important;
    padding: 1% 2% !important;
    text-align: center;
    font-size: 1.3vw;
    width: 20% !important;
    line-height: 1.5;
    -moz-appearance: textfield;
    color: #0F0C38;
}

.box-qty-input-container input::-webkit-inner-spin-button,
.box-qty-input-container input::-webkit-outer-spin-button{
   -webkit-appearance: none;
    margin: 0;
}

.box-qty-input-container button{
    background-color: #FFFFFF;
    border: 1px solid #E4E4E7;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2vw;
    padding: 0% 4%;
    line-height: 0;
    margin: 0% 2%;
    color: #0F0C38;
}

.box-qty-input-container button:hover{
    background-color: #faf7fe
}

.multiship-notice{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1.1vw;
    line-height: 1.5;
    color: #0F0C38;
}

.custom-notice{
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 1.1vw;
    line-height: 1.5;
    color: #581C87;
    margin-top: 2%;
}

.recommendation-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 5% 0%;
}

.recommendation-container .title{
    width: 100%;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 700;
    font-size: 1.25vw;
    line-height: 1.6;
    color: #0F0C38;
    padding-bottom: 2%;
}

.recommended-addon-container{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.recommended-addon{
    width: 30%;
    display: flex;
    flex-direction: column;
}

.recommended-addon .main-image{
    width: 100%;
    margin-bottom: 5%;
    height: auto;
}

.recommended-addon .addon-title{
    font-weight: 700;
    font-size: 1.05vw;
    line-height: 1.3;
    color: #0F0C38;
    margin-top: 5%;
}

.recommended-addon .price{
    font-size: 1.05vw;
    line-height: 1.3;
    color: #3F3D60;
}

.happybox-button.white{
    padding: 3% 0%;
}

.notice-container{
    background: white;
    border: 1px solid #F5EEFE;
    border-radius: 4px;
    box-sizing: border-box;
    width: 100%;
    padding: 4%;
    margin: 2% 0%;
    display: flex;
}

.notice-container .title{
    font-size: 1.15vw;
    font-weight: bold;
    line-height: 1.5;
}

.notice-container .subtitle{
    font-size: 1.15vw;
    line-height: 1.5;
}

.notice-container .main-image {
    width: 20%;
    padding: 1%;
    margin-right: 5%;
}

.summary-title,.summary-subtitle{
    font-size: 1.2vw;
    line-height: 1.5;
    margin: unset;
    color: #0F0C38
}
.summary-title{
    font-weight: bold;
}

.x-container{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: 5% 0% 3%;
    position: sticky;
    top: 2.5%;
}

.x-button{
    width: 24px;
    height: 24px;
    color: black;
    font-size: 1.8vw;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.product-summary .remove-all{
    text-align: right;
    color: #66498c;
    font-size: 1vw;
}

.remove-all:hover{
    text-decoration: underline;
}

    .price-summary-container .main-title{
        font-family: ff-more-web-pro-condensed, Karla, sans-serif;
        font-size: 1.5vw;
        line-height: 1.45;
        display: flex;
        align-items: center;
        letter-spacing: 0.03em;
        color: #0F0C38;
    }

    .item-summary{
        border-top: 1px solid #D1D5DB;
        padding: 3% 0%;
    }

    .item-title{
        font-family: ff-more-web-pro-condensed, Karla, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 1.5vw;
        line-height: 1.5;
        color: #0F0C38;
        margin-bottom: 2%;
    }

    .subtotal-container,.taxes-container{
        display: flex;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: #0F0C38;
        font-family: 'Karla';
        font-style: normal;
        font-weight: 700;
    }

    .subtotal-container p,.taxes-container p{
        margin: unset;
    }

    .subtotal-container{
        font-size: 1.4vw;
        line-height: 1.6;
        padding-bottom: 5%;
    }

    .taxes-container{
        font-size: 1.15vw;
        line-height: 150%;
        border-top: 1px solid #D1D5DB;
        padding-top: 3%;
    }

    .taxes-container strong{
        font-weight: 400;
    }

    .box-total{
        width: 100%;
        font-weight: 400;
        font-size: 1.15vw;
        line-height: 1.4;
        color: #0F0C38;
        margin-bottom: 5%;
    }

    .box-total p,.item-total p{
        margin: unset;
    }

    .total-container{
        display: flex;
        justify-content: space-between;
    }

    .individual-price{
        font-style: italic;
    }

    .item-total{
        display: flex;
        justify-content: space-between;
        width: 100%;
        font-weight: 700;
        font-size: 1.15vw;
        line-height: 150%;
        color: #0F0C38;
    }

    .total-container .service-fee{
        color: #5048E5;
    }

    .blue-legend{
        font-family: 'Karla';
        font-size: 1vw;
        line-height: 1.43;
        color: #5048E5;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .purple-legend{
        font-family: 'Karla';
        font-size: 1vw;
        line-height: 1.43;
        color: #66498c;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .blue-legend img{
        width: 3%;
        margin-right: 2%;
    }

    .complete-box{
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 5%;
        background-color: #f9fafb;
        position: sticky;
        bottom: 0%;
    }

    .complete-box .happybox-button{
        width: 100%;
    }

    .notice-container a{
        font-size: 1vw;
        text-decoration: underline;
        color: #a01adb;
        cursor: pointer;
    }

    .extended-block{
    background-color: #ffebe0;
    border: 1px solid gray;
    font-size: 0.9vw;
    border-radius: 8px;
    text-align: center;
    padding: 0.5rem 0.5rem;
    position: absolute;
    left: 5%;
    right: 5%;
    top: 5%;
    bottom: 25%;
    line-height: 1.2;
}

.extended-block .close{
    position: absolute;
    border-radius: 50%;
    background-color: #fff;
    line-height: 1;
    border: 1px solid gray;
    aspect-ratio: 1;
    font-size: 0.8rem;
    width: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -.5rem;
    right: -.5rem;
}

.extended-block .arrow-t {
    width: 0;
    height: 0;
    border-top: 10px solid gray;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    position: absolute;
    bottom: -10px;
    right: 5%;
}

.extended-block .arrow-t .inner {
    position: relative;
    top: -11px;
    right: 6px;
    width: 0;
    height: 0;
    border-top: 9.5px solid #ffebe0;
    border-right: 6.5px solid transparent;
    border-left: 6.5px solid transparent;
}

.alert-overlay{
    left: 5%;
    right: 5%;
    top: 0%;
    bottom: 25%;
    z-index: 1;
    background-color: rgba(255, 0, 0, 0.2);
    position: absolute;
}

.alert-icon{
    width: 20%;
    position: absolute;
    top: 5%;
    right: 15%;
    cursor: pointer;
    z-index: 1;
    animation: wobble 2s ease infinite;
}

@keyframes wobble {
  0% { transform: translateX(0%); }
  15% { transform: translateX(-25%) rotate(-5deg); }
  30% { transform: translateX(20%) rotate(3deg); }
  45% { transform: translateX(-15%) rotate(-3deg); }
  60% { transform: translateX(10%) rotate(2deg); }
  75% { transform: translateX(-5%) rotate(-1deg); }
  100% { transform: translateX(0%); }
}

    @media screen and (max-width: 767px){
        .cart-container{
            display: none !important;
        }
    }
</style>